import { routeName } from 'ember-route-state/utils/route-name.js';
import { routeParentName } from 'ember-route-state/utils/route-parent-name.js';

export class RouteQueryState {
  byRoute = {};
  mergeForRoute(route) {
    route = routeName(route)
    let query;
    do {
      if (this.byRoute[route]) {
        query = { ...this.byRoute[route], ...(query || {}) };
      }
    } while (route = routeParentName(route));
    return query || {};
  }
  routeChange(name, queryParams) {
    this.byRoute[name] = queryParams;
  }
}
